/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import { Toast } from 'vant'
import { RES_ERROR_STATUS } from '../utils/constants'
import router from '../router'
// import * as Sentry from "@sentry/browser";

Toast.allowMultiple()
Toast.setDefaultOptions({ duration: 2000 })

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    router.replace({
        path: '/login',
        query: {
            redirect: router.currentRoute.fullPath
        }
    })
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:
            toLogin()
            break
        // 403 token过期
        // 清除token并跳转登录页
        case 403:
            Toast({
                className: 'spinner-loading',
                message: '登录过期，请重新登录',
                overlay: true
            })
            router.push('/login')
            localStorage.removeItem('token')
            // store.commit('loginSuccess', null);
            setTimeout(() => {
                toLogin()
            }, 1000)
            break
        // 404请求不存在
        case 404:
            Toast({
                className: 'spinner-loading',
                message: '请求的资源不存在',
                overlay: true
            })
            break
        default:
            console.log(other)
    }
}
let reqNum = 0
let toastLoading
function startLoading() {
    if (reqNum === 0) {
        toastLoading = Toast.loading({
            duration: 0,
            className: 'spinner-loading',
            message: '加载中...',
            overlay: true,
            loadingType: 'spinner'
        })
    }
    reqNum++
}

function endLoading() {
    // 延迟 300ms 再调用 closeLoading 方法, 合并300ms内的请求
    setTimeout(closeLoading, 300)
}

function closeLoading() {
    if (reqNum <= 0) return
    reqNum--
    if (reqNum == 0) {
        toastLoading.clear()
    }
}
// 创建axios实例
var instance = axios.create({
    timeout: 1000 * 20,
    baseURL: process.env.VUE_APP_DOMAIN
})
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
        // // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
        // const token = store.state.token;
        // token && (config.headers.Authorization = token);
        //一下几种请求,直接返回请求结果,不显示loading
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
        config.headers['Accept'] = 'application/json, text/javascript, */*; q=0.01'
        if (
            config.url.includes('checklogin') ||
            config.url.includes('customerexport') ||
            config.url.includes('readnotice')
        ) {
            return config
        } else {
            startLoading()
            return config
        }
    },
    error => {
        // Sentry.captureMessage(error);
        Promise.error(error)
    }
)

// 响应拦截器
instance.interceptors.response.use(
    //     // 请求成功
    // res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
    res => {
        if (
            !res.config.url.includes('checklogin') &&
            !res.config.url.includes('customerexport') &&
            !res.config.url.includes('readnotice')
        ) {
            // if (!['/api/?d=admin&c=adminuser&m=deleteadminuser'].includes(res.config.url)) {
            //     // 调试toast样式用
            //     endLoading()
            // }
            endLoading()
        }
        // 文字提示--默认的状态码错误
        let ss = res.data.status ? res.data.status : res.status
        if (RES_ERROR_STATUS[ss]) {
            Toast(RES_ERROR_STATUS[ss])
            if (ss == 10000006 || ss == 10000011) {
                router.push('/login')
            }
            // Promise.reject(res);
        }
        return Promise.resolve(res.data)
    },
    //     // 请求失败
    error => {
        endLoading()
        // Sentry.captureMessage(error);
        if (error) {
            Toast({
                className: 'spinner-loading',
                message: '服务器错误',
                overlay: true
            })
            setTimeout(() => {
                Toast({
                    className: 'spinner-loading',
                    message: `错误信息为：${error}`,
                    overlay: true
                })
            }, 100)
        }
        if (!window.navigator.onLine) {
            Toast({
                className: 'spinner-loading',
                message: '请检查网络连接',
                overlay: true
            })
        }
        const { response } = error
        if (response) {
            // 请求已发出，但是不在2xx的范围
            errorHandle(response.status, response.data.message)
            return Promise.reject(response)
        }
    }
)

export { instance as axios }
